export default "__VITE_ASSET__CknTD7D___"